const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');
/**
 * Defines the Scorm Viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze the resource defined to manage Analyze
 * @argument {ScormContent} ScormContent the resource defined to manage Scorm Content
 * @argument {ScormView} ScormView the resource defined to manage ScormRegistrations
 */
app.directive('scormViewer', ['Application', 'Authorization', 'Analyze', 'ScormContent', 'ScormRegistrations', 'ScormView', '$filter', 'ContentAuth', 'SurveyHelper', 'Content', '$window', '$http', '$location', '$timeout', '$translate', function(Application, Authorization, Analyze, ScormContent, ScormRegistrations, ScormView, $filter, ContentAuth, SurveyHelper, Content, $window, $http, $location, $timeout, $translate) {
    return {
      restrict: 'E',
      scope: {
        fullData: '=',
        preview: '=',
        postFinish: '&?',
        onComplete: '&?',
        trackId: '=?',
        contentId: '=?',
        loading: '=?',
        journeyId: '=?'
      },
      template: require('../../templates/directives/scorm-viewer.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          var routeParameters = Application.navigation.getRouteParameters();
          var user = self.user = Authorization.getAuthToken().user;
          var originalUrl = Application.navigation.getUrl();
          self.showCertificate = true;
          self.expandSurvey = false;
          self.hideSurvey = true;          
          self.closeCertificate = function() {
            self.showCertificate = false;
          };

          self.initials = '';
          self.type = 'scorm';
          self.is_a_preview = $scope.preview || false;
          self.scorm = {};
          self.scormRegistration = null;
          self.launch_url = null;
          self.xOut = null;
          self.closeRequested = false;
          self.creator_notes_available = false;
          self.itemReturn = {
            scorm: false,
            scormRegistration: false
          };
          self.nextCourse = null;
          self.userTaken = {};
          self.topicClass = '';
          self.activeTab = "information";
          self.scorm_about_toggle = false;
          self.scorm_limit = parseInt(Authorization.getAuthToken().company.scorm_limit) || 300;
          self.scorm_limit_enforced = false;
          self.scorm_limit_enforcement = Authorization.getAuthToken().company.scorm_limit_enforcement || 'soft';
          self.block_registration = false;
          self.registrations_count = 0;
          self.detailWhileViewing = false;
          self.in_track = new RegExp('track').test(originalUrl) || !!$scope.trackId;
          self.inJourney = !!$scope.journeyId;
          self.translations = {};
          self.markedCompleted = false;

          self.recordSurveyView = () => {
            Analyze.record({resource: 'views'}, {content: self.scorm.surveys[0].survey_id, content_type: 'survey'});
          }

          self.setTopic = function() {
            if (self.topic) {
              self.topicClass = 'svgicon--' + self.topic.split(' ')[0].toLowerCase();
            }
          };

          self.mobileViewport = {
            defaultStyles: 'background:#f7f7f7;max-width: 2440px; width: 100vw; height: calc(100vh - 70px); max-height: 56.25vw; display: block;',
            currentDims: {
              width: window.innerWidth,
              height: window.innerHeight
            },
            orientation: function(){
              if(self.mobileViewport.width > self.mobileViewport.height){
                return 'landscape';
              } else {
                return 'portrait';
              }
            },
            getCurrentDims: function(){
              return self.mobileViewport.currentDims;
            },
            updateDims: function(){
              self.mobileViewport.currentDims.width = window.innerWidth;
              self.mobileViewport.currentDims.height = window.innerHeight;
            },
            showAsFullscreen: function(){
              if (self.mobileViewport.getCurrentDims().width < 870 && (self.mobileViewport.orientation() !== 'landscape')){
                return true;
              };
              return false;
            },
            setPlayerDims: function(dims){
              if(self.mobileViewport.getCurrentDims().width < 870 && (self.mobileViewport.orientation() !== 'landscape')){
                var checkExistsInterval = setInterval(function(){
                  var playerFrame = document.querySelector('#playeriframe');
                  var topbar = document.querySelector('.interactionbar');
                  if(playerFrame !== null && topbar !== null) {
                    var topbarOffset = topbar.clientHeight;
                    playerFrame.style.maxHeight = 'none';
                    playerFrame.style.width = dims.width + "px";
                    playerFrame.style.height = (dims.height - topbarOffset) + "px";
                    clearInterval(checkExistsInterval);
                  }
                },100);
              } else {
                self.mobileViewport.resetDims();
              }
            },
            resetDims: function(){
              var playerFrame = document.querySelector('#playeriframe');
              var checkExistsInterval = setInterval(function(){
                if(playerFrame !== null) {
                  playerFrame.setAttribute('style',self.mobileViewport.defaultStyles);
                  clearInterval(checkExistsInterval);
                }
              },100);
              },
            init: function(){
              self.mobileViewport.updateDims();
              self.mobileViewport.setPlayerDims(self.mobileViewport.currentDims);
            },
            onResize: function (){
              self.mobileViewport.updateDims();
              self.mobileViewport.setPlayerDims(self.mobileViewport.currentDims);
            }
          };
          setTimeout(function(){
            self.mobileViewport.init();
          },2000)
          window.onresize = self.mobileViewport.onResize;

          self.fullscreen = {
            onChange: function(){
              if (document.fullscreenElement) {
                self.mobileViewport.showAsFullscreen()
              } else {
                self.mobileViewport.resetDims();
              }
            }
          };

          self.makeDuration = function(time) {
            var mins = ~~(time / 60);
            var secs = time % 60;

            var hrs = ~~(time / 3600);
            var mins = ~~((time % 3600) / 60);
            var secs = time % 60;

            var ret = "";

            if (hrs > 0) {
              ret += "" + hrs + (hrs === 1 ? " hr" : " hrs") + " ";
            }

            ret += "" + mins + (mins === 1 ? " min" : " mins");

            return ret;
          };
          self.image = function() {
            if (self.scorm.banner_image || self.scorm.image) {
              var imageUrl = self.scorm.banner_image ? self.scorm.banner_image : self.scorm.image;
              return Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + '/' + imageUrl;
            }
            return '';
          };
          self.trimHtml = function(text) {
            if (!text) {
              return self.translations['scormviewer.no_text'];
            }

            var div = document.createElement("div");
            div.innerHTML = text;
            var newText = div.textContent || div.innerText || "";

            var trimTo = 150;
            var addDots = false;
            if (newText.length > 150) {
              addDots = true;
            }

            newText = $filter('limitTo')(newText, trimTo);
            return addDots ? newText + '...' : newText;
          };

          self.goToCourse = function() {

            if (!self.scormRegistration) {
              if ($scope.preview) {
                self.loadingScorm = false;
                self.scormRegistration = {};
                self.createPlayerUrl();
                return;
              }
              if (self.scorm_limit_enforced === true) {
                self.showNoRegistrations = true;
                return;
              }
              var initRegistration = {
                local: true,
                studentId: self.user._id,
                activityId: self.scorm._id,
                data: JSON.stringify({status: 'incomplete'})
              };

              return ScormRegistrations.setDataUrl(initRegistration).$promise
              .then(function(data) {
                self.scormRegistration = {};
                self.createPlayerUrl();
                self.loadingScorm = false;
                if (self.in_track) {
                  $scope.loading = false;
                }
              }).catch(function(error) {
                console.log('error: ', error);
              });
            }
          };

          self.displayTime = function(time) {
            var mins = ~~(time / 60);
            var secs = time % 60;

            var hrs = ~~(time / 3600);
            var mins = ~~((time % 3600) / 60);
            var secs = time % 60;

            var ret = "";

            if (hrs > 0) {
              ret += "" + hrs + (hrs === 1 ? " hr" : " hrs") + " ";
            }

            ret += "" + mins + (mins === 1 ? " min" : " mins");
            return ret;
          };

          self.makeInitials = function() {
            var names = self.scorm.creator_name.split(' ');
            self.initials += names[0][0];
            if (names.length > 1) {
              self.initials += names[names.length - 1][0];
            }
            self.initials = self.initials.toUpperCase();
          };
          self.checkLearnItems = function() {
            if (!self.scorm || !self.scorm.learn_items || !self.scorm.learn_items.length) {
              return false;
            }
            for (var i = 0; i < self.scorm.learn_items.length; i++) {
              if (self.scorm.learn_items[i]) {
                return true;
              }
            }
            return false;
          };

          self.onClose = function() {
            Application.navigation.back();
            self.closeRequested = true;
          };

          self.createPlayerUrl = function() {
            if (!self.scorm || !self.scorm.self_hosted) {
              return;
            }

            window.scormPreview = false;
            window.sdht = Authorization.getAuthToken().authtoken;
            window.sdad = Application.API;
            window.addEventListener("message", function(event) {
              if (event && event.data && event.data === 'postFinish' && !self.postFinishCalled) {
                self.postFinishCalled = true;
                if (($scope.preview || self.in_track || self.inJourney) && $scope.postFinish) {
                  $scope.postFinish({id: self.contentId || null});
                  return;
                }
                if (self.closeRequested || originalUrl !== Application.navigation.getUrl()) {
                  return;
                }
                $timeout(function() {
                  Application.navigation.back();
                  $scope.$apply();
                }, 1);
              }
              if (event && event.data && event.data === 'postInit') {
                $timeout(function() {
                  self.packageInitLoading = false;
                  if (self.in_track) {
                    $scope.loading = false;
                  }
                  $scope.$apply();
                  document.onfullscreenchange = self.fullscreen.onChange;
                }, 1);
              }
              if (event && event.data && event.data === 'statusCompleted' && !self.markedCompleted) {
                self.markedCompleted = true;
                self.certificateDate = new Date();
                self.showCertificate = true;
                if ($scope.onComplete) {
                  $scope.onComplete();
                }

                $scope.$apply();
              }
            });

            if ($scope.preview) {
              window.scormPreview = true;
            }

            var courseDirectory = self.user.company + '/' + self.scorm._id;
            window.courseDirectory = '/scorm-package/' + courseDirectory + '/';
            window.courseId = self.scorm._id;
            window.studentName = self.user.last_name + ',' + self.user.first_name;
            window.studentId = self.user._id;

            // self.packageInitLoading = true;
            function setIframe (data) {
              $timeout(function() {
                var iframe = document.getElementById('playeriframe');
                if (!iframe || !iframe.contentWindow) {
                  self.playerUrl = 'exists';
                  $scope.$apply();
                  setIframe(data);
                  return;
                }
                try {
                  iframe.contentWindow.contents = data.data;
                  iframe.src = 'javascript:window["contents"]';
                } catch (error) {
                  console.log('error: ', error)
                }
              }, 10);
            }

            $http({
              method: 'POST',
              url: './cloudfront-cookie/scorm',
              headers: {
                'Authorization': 'AuthToken token=' + Authorization.getAuthToken().authtoken,
                'Content-Type': 'application/json'
              },
              data: JSON.stringify({host: $location.host()})
            }).then(cfResponse => {
              $http({
                type: "GET", 
                url: './player',
                headers: {
                  'Authorization': 'AuthToken token=' + Authorization.getAuthToken().authtoken
                }
              }).then(function(data) {
                self.playerUrl = 'exists';
                setIframe(data);
              }).catch(function(error) {
                console.log('error: ', error)
              });
            }, errorResponse => {
              // If they don't get a cookie, they probably won't be able to view the content.
              // We should consider if we want to make a visible error on this.  We don't when
              // the player fails to load, so for consistency's sake we aren't here.
            });

            self.loadingScorm = false;
          };

          self.initialize = async function() {
            self.contentId = $scope.contentId || routeParameters.id || null;
            // self.loadingScorm = true;
            self.hasLearnItems = true;
            if (!Authorization.getAuthToken().company.scorm) {
              Application.notifications.setError('SCORM Content is unavailable for the company.');
              Application.navigation.goToHome();
            }

            if (!self.contentId && !$scope.fullData && !self.is_a_preview) {
              Application.navigation.goToHome();
              return;
            }

            if ($scope.preview) {
              self.is_a_preview = true;
              self.loadingScorm = false;
              if ($scope.fullData) {
                self.scorm = $scope.fullData;
                window.sslaConfigSetup = self.scorm.ssla_config;
                if (self.scorm.average_rating) {
                  self.rating = Math.round(self.scorm.average_rating * 5) / 100;
                }
              } else {
                self.scorm = {};
                $scope.$watch('fullData', function(newVal, oldVal) {
                  if (!newVal || newVal === oldVal) {
                    return;
                  }
                  self.scorm = newVal;
                  window.sslaConfigSetup = self.scorm.ssla_config;
                  if (self.scorm.average_rating) {
                    self.rating = Math.round(self.scorm.average_rating * 5) / 100;
                  }
                }, true);
              }
              return;
            }

            let foundScorm;

            try {
              foundScorm = await ScormContent.get({subresource: self.contentId, fields: 'company,user,title,description,duration,banner_image,images,properties,tags,linked_category,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,createdAt,updatedAt,self_hosted,certificate,certificate_data,allow_comments,rating_configuration,average_rating,groups,ssla_config,surveys', 'company-populate': 'scorm_limit scorm_limit_enforcement,self_hosted,rating_configuration,average_rating'}).$promise;

              const allowed = await ContentAuth.allowView(foundScorm);

              if (!allowed) {
                self.loadingScorm = false;
                Application.messaging.addMessage({type: 'error', text: self.translations['scormviewer.permission_error'], duration: 5});
                Application.navigation.goToHome();
                $scope.$apply();
                return;
              }  
            } catch (error) {
              console.log('Error occured getting scorm ', self.contentId, error);
              self.loadingScorm = false;
              Application.messaging.addMessage({type: 'error', text: 'Unable to load this content.', duration: 5});
              $scope.$apply();
              return;
            }

            ScormView.registration({userid: user._id, contentid: self.contentId}, async function(registrationResults) {
              if (!registrationResults) {

                if (foundScorm.company && foundScorm.company.scorm_limit_enforcement) {
                  self.scorm_limit_enforcement = foundScorm.company.scorm_limit_enforcement;
                }
                ScormRegistrations.count({subresource: 'all', createdAt: '$gte,date-' + moment().startOf('month').format('MM-DD-YY')}).$promise.then(function(results) {
                  if (results.count) {
                    self.registrations_count = parseInt(results.count);
                    if ((self.registrations_count >= self.scorm_limit) && self.scorm_limit_enforcement === 'block') {
                      self.scorm_limit_enforced = true;
                    }
                  }

                  Analyze.record({resource: 'views'}, {content: foundScorm._id, content_type: 'scorm'});
                  Application.analyticsProvider.trackEvent('scorm_viewed', {content: foundScorm._id, content_type: 'scorm', title: foundScorm.title});
                  self.scorm = foundScorm;
                  window.sslaConfigSetup = self.scorm.ssla_config;
                  if (self.scorm.average_rating) {
                    self.rating = Math.round(self.scorm.average_rating * 5) / 100;
                  }
                  if (!self.checkLearnItems()) {
                    self.scorm_about_toggle = true;
                  }
                  self.setTopic();
                  if (self.scorm.self_hosted) {
                    if (self.in_track && !self.scorm_limit_enforced) {
                      self.goToCourse();
                    }
                    return;
                  }

                  self.itemReturn.scorm = true;
                  self.loadingScorm = false;
                });
                return;
              }
              self.scormRegistration = registrationResults.registration;
              if (self.in_track && $scope.onComplete && (self.scormRegistration.status === 'completed' || self.scormRegistration.status === 'passed')) {
                $scope.onComplete();
              }
              if (foundScorm.surveys?.length && (self.scormRegistration.status === 'completed' || self.scormRegistration.status === 'passed')) {
                self.surveyId = foundScorm.surveys[0].survey_id;
                const hideInContext = self.inJourney || self.in_track;
                self.hideSurvey = await SurveyHelper.hideSurvey(hideInContext, self.surveyId, foundScorm._id);
                $scope.$apply();
              }
              self.scorm = registrationResults.registration.content;
              window.sslaConfigSetup = self.scorm.ssla_config;
              if (self.scorm.average_rating) {
                self.rating = Math.round(self.scorm.average_rating * 5) / 100;
              }
              if (self.in_track) {
                $scope.loading = true;
              }
              if (self.scorm.self_hosted) {
                self.createPlayerUrl();
                return;
              }
              self.launch_url = registrationResults.launch_url;
              self.loadingScorm = false;
            }, function(error) {
              if (error.status && error.status === 404) {
                ScormRegistrations.count({subresource: 'all', createdAt: '$gte,date-' + moment().startOf('month').format('MM-DD-YY')}).$promise.then(function(results) {
                  if (results.count) {
                    self.registrations_count = parseInt(results.count);
                    if ((self.registrations_count >= self.scorm_limit) && self.scorm_limit_enforcement === 'block') {
                      self.scorm_limit_enforced = true;
                    }
                  }

                  Analyze.record({resource: 'views'}, {content: foundScorm._id, content_type: 'scorm'});
                  Application.analyticsProvider.trackEvent('scorm_viewed', {content: foundScorm._id, content_type: 'scorm', title: foundScorm.title});
                  self.scorm = foundScorm;
                  window.sslaConfigSetup = self.scorm.ssla_config;
                  if (self.scorm.average_rating) {
                    self.rating = Math.round(self.scorm.average_rating * 5) / 100;
                  }
                  if (!self.checkLearnItems()) {
                    self.scorm_about_toggle = true;
                  }
                  self.itemReturn.scorm = true;
                  self.setTopic();
                  if (self.in_track && !self.scorm_limit_enforced) {
                    self.goToCourse();
                    return;
                  }
                  self.loadingScorm = false;
                });
                return;
              }
              console.log('Error occured getting scorm-registration ', self.contentId, error);
              self.loadingScorm = false;
            });
          };

          $translate([
            "scormviewer.no_text",
            "scormviewer.permission_error",
            "scormviewer.permission_error"
          ]).then(function (translations) {
            self.translations = translations;
            self.initialize();
          });

        }],
      controllerAs: 'viewer'
    };
  }]);
